import { Visible, Card } from '@leroy-merlin-br/backyard-react-ui'

import AssistedSaleMobileThumb from 'reactGarden/ProductThumb/components/assisted-sale/AssistedSaleMobileThumb'

import * as S from './styled'

const AssistedSaleProductList = ({ products }) => (
  <Visible untilKilo kilo>
    <Card>
      <S.Wrapper>
        {products
          .filter(product => 'assistedSale' in product)
          .map(product => (
            <AssistedSaleMobileThumb key={product.id} product={product} />
          ))}
      </S.Wrapper>
    </Card>
  </Visible>
)

export default AssistedSaleProductList
